export const getColumns = () => {
  return [
    {
      'Header': 'MODELO',
      'accessor': 'modelId',
      'width': 4,
    },
    {
      'Header': 'DESCRIPCIÓN',
      'accessor': 'description',
      'width': 9,
    },
    {
      'Header': 'ESTADO',
      'accessor': 'status',
      'width': 1,
      'Filter': () => null,
    },
  ];
};

